/* import __COLOCATED_TEMPLATE__ from './label-cell.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';

interface CellLabelCellSignature {
  Args: {
    cell: unknown;
    column: unknown;
    row: unknown;
    scrollToRow: unknown;
  };
}

const CellLabelCellComponent = templateOnlyComponent<CellLabelCellSignature>();

export default CellLabelCellComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Cell::LabelCell': typeof CellLabelCellComponent;
    'cell/label-cell': typeof CellLabelCellComponent;
  }
}
